import React from 'react'

function WebsiteService()
{
    return(
        <div className="sub_page_wrapper page_content">
            <h3>Email Services, Collaboration and Website Management</h3>

            <p>
            Internal and external communication is the life flow of any organizations’ operational success.
Smart KS understands this critical requirement and has thus acquire skills and capabilities in the
management of communication systems within the organisation.
            </p>

            <p>
            We have expertise in email server management, that controls all internal and external email
flows. We will create and assign email addresses to employees and delete once they have left
the organisation.
            </p>

            <p>
            We have capabilities in the deployment and management of collaborative communication
systems such as Microsoft teams, Skype for business and Zoom. We will do employee user
training of all deployed collaboration tools. A company website is the key communication tool
between an organisation and its stakeholders.
            </p>

            <p>
            Smart KS has the capabilities in the development of websites and mobile applications (Apps). Through astute scooping,
using business analysis techniques, our team will determine the clients needs and design
an optimal website / app that will enhance the company image. Using complex algorithms, the
website can be made interactive so we can provide desired services to customers.
            </p>
        </div>
    );
}

export default WebsiteService;